import React from 'react';
import PropTypes from 'prop-types';
import RcIf from 'rc-if';
import Reflux from 'reflux';
import AppStore from '../../AppStore';
import AppActions from '../../AppActions';

export default class OtherOptions extends Reflux.Component {
    constructor (state) {
        super(state);
        this.store = AppStore;
    }
    selectOption = (sentence) => {
        if (!this.state.enableEditing) {
            return;
        }
        AppActions.selectOption(sentence);
    }
    render () {
        const { otherOptions } = this.props;
        return <RcIf if={otherOptions && otherOptions.length > 0} >
          <div className='box'>
            <h5>Otras Opciones</h5>
            <ul className='option-left'>
              {otherOptions.map((option, index) => {
                  return (
                    <li key={index}>
                      <a onClick={() => { this.selectOption(option.sentence); }} >{option.sentence}</a>
                    </li>
                  );
              })
            }
            </ul>
          </div>
        </RcIf>;
    }
}

OtherOptions.propTypes = {
    otherOptions: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/components/topic/OtherOptions.js